/** Backend blocks edit/delete when the item is reserved on an order or already sold. */
export function isProductItemReservedOrSold(
  state: string | undefined
): boolean {
  return state === "RESERVED" || state === "SOLD";
}
